module.exports = __webpack_public_path__ + "img/traveler.f007136d.png";